export default "__VITE_ASSET__CP7eu3Lz__"